import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { Button, Message, Segment, Select } from "semantic-ui-react";
import { AppState } from "../../../../../store/configureStore";
import { Loading } from "../../../../Loading/Loading";
import { AddVertexLimits, IVerticesFiltering, SetSelectedVertexFilteringType, SetVerticesLimits, vertexFilteringTypeDropdownItems, verticesFilteringInit } from "../../../../../store/verticesFilteringReducer";
import { VerticesFilteringTable } from "./VerticesFilteringTable";
import "../NPShift/NPShift.css";
import { ValidationProcess } from "../../../../../store/validationProcess";

const checkMinMaxValues = (vertexLimitsArray: IVerticesFiltering) => {
    let ok = true;
    for (let el in vertexLimitsArray.values) {
        if (Number(vertexLimitsArray.values[el].minValue) > Number(vertexLimitsArray.values[el].maxValue)) {
            ok = false;
            break;
        }
    }
    return ok;
};

/*
const formatTimestampsOptions = (timestamps: number[]) => {
    const activeTimestampsOptions: ITimestamp[] = [];
    timestamps.forEach(x => {
        activeTimestampsOptions.push({
            key: x,
            text: x.toString().padStart(2, "0") + ":30",
            value: x,
        });
    });
    return activeTimestampsOptions;
};
*/

export const VerticesFiltering = () => {
    const dispatch = useDispatch();
    const zipFile = useSelector((state: AppState) => state.files.zipFile);
    const activeTimestampsOptions = useSelector((state: AppState) => state.timestamps.timestamps);
    const verticesLimits = useSelector((state: AppState) => state.verticesFiltering.verticesLimits);
    const ahc = useSelector((state: AppState) => state.verticesFiltering.ahc);
    const [selectedTimestamp, setSelectedTimestamp] = useState<number>(-1);
    const [selectedVerticesLimits, setSelectedVerticesLimits] = useState<IVerticesFiltering>();
    const [loading, setLoading] = useState(false);
    const [showSumErrorMessage, setShowSumErrorMessage] = useState(false);
    const [showSavedMessage, setShowSavedMessage] = useState(false);
    const validationProcess = useSelector((state: AppState) => state.validationProcess.process);
    const selectedVertexFilteringType = useSelector((state: AppState) => state.verticesFiltering.vertexFilteringType);

    const applyVerticesLimitsToSelectedTimestampsOrScenarios = () => {
        const verticesFilteringArray: IVerticesFiltering[] = [];
        for (const activeTimestamp of activeTimestampsOptions) {
            const item: IVerticesFiltering = {
                hour: activeTimestamp.key,
                values: selectedVerticesLimits!.values,
            };
            verticesFilteringArray.push(item);
        }
        dispatch(SetVerticesLimits(verticesFilteringArray));
        setShowSavedMessage(true);
        setTimeout(() => setShowSavedMessage(false), 2000);
    };

    const handleAddVertexLimits = () => {
        selectedVerticesLimits!.hour = selectedTimestamp;
        dispatch(AddVertexLimits(selectedVerticesLimits!));
        setShowSavedMessage(true);
        setTimeout(() => setShowSavedMessage(false), 2000);
    };

    useEffect(() => {
        if (selectedVerticesLimits) {
            let ok = checkMinMaxValues(selectedVerticesLimits);
            if (ok === true) {
                setShowSumErrorMessage(false);
            }
            else {
                setShowSumErrorMessage(true);
            }
        }
    }, [selectedVerticesLimits]);

    useEffect(() => {
        if (zipFile && selectedTimestamp > -1) {
            setLoading(true);
            const npShift = verticesLimits.filter(x => x.hour === selectedTimestamp)[0];
            if (npShift) {
                setSelectedVerticesLimits(npShift);
            }
            else {
                setSelectedVerticesLimits(verticesFilteringInit);
            }
            setLoading(false);
        }
    }, [zipFile, selectedTimestamp, verticesLimits]);

    let component = null;
    if (loading) {
        component = <Loading />
    } else if (zipFile && selectedTimestamp !== -1 && activeTimestampsOptions.some(vendor => vendor.key === selectedTimestamp) && selectedVerticesLimits) {
        component =
            [
                <p key="t1">Core Hubs</p>,
                <VerticesFilteringTable
                    selectedVerticesLimits={selectedVerticesLimits}
                    setSelectedVerticesLimits={setSelectedVerticesLimits}
                    ahc={false}
                    disabled={false}
                    key="vft1"
                />,
                <p key="t2">AHC Hubs</p>,
                <VerticesFilteringTable
                    selectedVerticesLimits={selectedVerticesLimits}
                    setSelectedVerticesLimits={setSelectedVerticesLimits}
                    ahc={true}
                    disabled={!ahc}
                    key="vft2"
                />
            ]
    }

    return (
        <Segment className="np-shift-container transition-container">
            <div className="np-shift-header">
                <div>
                    <p>Timestamp</p>
                    <Select
                        selectOnBlur={false}
                        placeholder="Select a timestamp"
                        value={selectedTimestamp}
                        options={activeTimestampsOptions}
                        onChange={(e, data: any) => setSelectedTimestamp(+data.value)}
                    />
                    <Button
                        primary
                        content="Save Vertices Limits"
                        onClick={handleAddVertexLimits}
                        disabled={showSumErrorMessage || !selectedVerticesLimits}
                    />
                    <Button
                        primary
                        content={"Save settings to all " + (validationProcess === ValidationProcess.Ltcc ? "scenarios" : "timestamps")}
                        onClick={applyVerticesLimitsToSelectedTimestampsOrScenarios}
                        disabled={showSumErrorMessage || !selectedVerticesLimits}
                    />
                    <Select
                        placeholder="Select option"
                        //className="bottom-view-selector"
                        style={{ minWidth: '210px' }}
                        value={selectedVertexFilteringType}
                        options={vertexFilteringTypeDropdownItems}
                        onChange={(e, data: any) => {
                            dispatch(SetSelectedVertexFilteringType(data.value))
                        }}
                    />
                </div>
                {!zipFile ? <Message>Please upload a file</Message> : null}
                <CSSTransition
                    in={showSumErrorMessage}
                    timeout={400}
                    classNames="npshift-transition"
                    unmountOnExit
                >
                    <Message negative>
                        <Message.Header>Max Values should be greater than Min Values</Message.Header>
                    </Message>
                </CSSTransition>
                <CSSTransition
                    in={showSavedMessage}
                    timeout={400}
                    classNames="npshift-transition"
                    unmountOnExit
                >
                    <Message positive>
                        <Message.Header>Vertices Limits saved</Message.Header>
                    </Message>
                </CSSTransition>
            </div>
            {component}
        </Segment>
    );
};
